import Themeable from "vuetify/lib/mixins/themeable";
import { VCardTitle } from "vuetify/lib";

export default {
	name: "KDataTableSubheader",

	mixins: [ Themeable ],

	render() {
		return <VCardTitle
			class={{
				"text-caption": true,
				"grey darken-2": this.isDark,
				"grey lighten-3": !this.isDark
			}}
		>
			{this.$slots.default}
		</VCardTitle>;
	}
};
